import { Button, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { toast } from 'react-toastify';
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import { API } from '../../common/Constants';

const PreviewAA = ({ pdfurl }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const statusData = location.state;
    const applicationId = localStorage.getItem('applicationId');
    const agentId = localStorage.getItem('agentId');
    const { authData } = useContext(AuthenticationContext);
    const [guaranId, setGuaranId] = useState('');

    const fileName = `approval-advice-${Date.now()}.pdf`;

    // const queryData = { ...statusData, preview_counter_values: JSON.stringify(statusData.preview_counter_values) };
    const queryData = {
        ...statusData,
        preview_counter_values: JSON.stringify(statusData.preview_counter_values),
        fileName: fileName
    };
    const queryString = new URLSearchParams(queryData).toString();
    const fileObject = [
        {
            name: fileName,
            // value: `storage/pdfs/${fileName}`,
            value: `public/uploads/agent/${fileName}`,
        }
    ];
    const payload = {
        ...statusData,
        preview_counter_values: JSON.stringify(statusData.preview_counter_values),
        aa_files: fileObject,
    };
    const statusUpdate = async () => {
        const response = await ServerAPI.updateProductStatus(payload);
        if (response) {
            toast.success(response.message);
            navigate(-2);
        }
    }
    useEffect(() => {
        let guranIdVal = '';
        Object.entries(statusData).map(([key, value]) => {
            if (key.startsWith('guarantor')) {
                guranIdVal += `${value},`
            }
        })
        guranIdVal = guranIdVal.slice(0, -1);
        if (guranIdVal) {
            setGuaranId(guranIdVal);
        }
    }, [])
    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Loan Application</p>
                        </div>
                    </Col>
                </Row >
            </div >
            <div className="w-full h-auto flex justify-center p-5">
                <div className='flex justify-center px-4 xl:w-1/2'>
                    {/* <iframe src={`${API.BaseUrl}application/approval/advice/` + applicationId + "/" + authData.id + "/" + statusData?.application_product + `${guaranId ? `/${guaranId}` : ''}`} className='aa-height' id='pdf' title="PDF Viewer" width="100%" style={{ height: "900px" }} /> */}
                    <iframe src={`${API.BaseUrl}application/approval/advice/${applicationId}/${authData.id}/${statusData?.application_product}${guaranId ? `/${guaranId}` : ''}?${queryString}`} className='aa-height' id='pdf' title="PDF Viewer" width="100%" style={{ height: "900px" }} />
                </div>
            </div>
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white text-right">
                            <Button onClick={() => {
                                statusUpdate();
                            }} type='primary'> Issue AA</Button>
                        </div>
                    </Col>
                </Row >
            </div >
        </div>
    );
};

export default PreviewAA;